import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IAuthService } from '../../api';

@Component({
  selector: 'rr-signout-redirect-callback',
  template: '<div></div>',
})
export class SignoutRedirectCallbackComponent implements OnInit {
  constructor(private _authService: IAuthService, private _router: Router) {}
  ngOnInit(): void {
    this._authService.finishLogout().then(() => {
      this._router.navigate(['/'], { replaceUrl: true });
    });
  }
}
